const extractFieldValidations = ({ fieldAccesses, fieldName }) => {
  let inWhichStateOrderItBecomesNecessary = null;
  let validationType = null;
  let isMandatory = false;

  const fieldEntityName = fieldName?.split("_")?.[0];
  const fieldAG = fieldAccesses?.[fieldEntityName]?.find((eachAC) => eachAC?.fieldName === fieldName);

  if (typeof fieldAG?.isMandatory === "boolean") isMandatory = fieldAG?.isMandatory;
  if (fieldAG?.validationType) validationType = fieldAG?.validationType;
  if (
    typeof fieldAG?.inWhichStateOrderItBecomesNecessary === "number" &&
    !isNaN(fieldAG?.inWhichStateOrderItBecomesNecessary)
  ) {
    inWhichStateOrderItBecomesNecessary = fieldAG?.inWhichStateOrderItBecomesNecessary;
  }

  return { inWhichStateOrderItBecomesNecessary, validationType, isMandatory };
};

export default extractFieldValidations;
